module.exports = __webpack_public_path__ + "static/1-5c8d4d60418bb88a2d9bd5bac5b063c9.png";